import dotImg from '@assets/images/capability_dot.png'
export default function getCapabilityOption(textColor?: string, bgColor?: string){
    return {
        title: {
            text: ''
        },
        legend: {
            data: []
        },
        radar: {
            shape: 'polygon', // 多边形（默认），也可以是 'circle'
            radius: '74%',
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(8, 77, 205, 1)',
                    width: 1
                },
            },
            axisName: {
                show: true,
                color: textColor || 'rgba(255, 255, 255, 0.9)',
                fontSize: 14,
                fontFamily: 'HarmonyOS Sans SC'
            },
            axisLabel: {
                customValues: [0, 2, 4, 6, 8, 10],
                color: textColor || 'rgba(171, 202, 255, 1)',
                verticalAlign: 'middle',
                align: 'right',
                rotate: 0,
                fontSize: 12,
                height: 16,
                fontFamily: 'HarmonyOS Sans SC'
            },
            indicator: [
                { name: '时间', min: 0, max: 10, axisLabel: { show: true } },
                { name: '油门', min: 0, max: 10, axisLabel: { show: false } },
                { name: '方向舵', min: 0, max: 10, axisLabel: { show: false } },
                { name: '升降舵', min: 0, max: 10, axisLabel: { show: false } },
                { name: '副翼', min: 0, max: 10, axisLabel: { show: false } },
            ],
            splitArea: {
                areaStyle: {
                    color: bgColor || '#20232B',
                    shadowBlur: 20,
                    shadowColor: '#2174FF',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    opacity: 0.2
                }
            },
            splitLine: {
                lineStyle: {
                    // 使用深浅的间隔色
                    color: ['#2174FF', '#084DCD', '#084DCD', '#084DCD', '#084DCD'],
                }
            }
        },
        series: [
            {
                name: '能力分析',
                type: 'radar',
                data: [
                    {
                        value: [8, 6, 4, 8, 6],
                        name: '能力分析',
                        areaStyle: { // 填充区域的样式（对应你图中的蓝色填充）
                            color: 'rgba(33, 116, 255, 0.8)' // 半透明蓝色
                        },
                        lineStyle: { // 轮廓线的样式
                            color: 'rgba(33, 116, 255, 1)'
                        },
                        symbol: 'image://' + dotImg, // 数据点的形状（对应你图中的白色圆点）
                        symbolSize: 8, // 数据点大小
                    },
                ]
            }
        ]
    }
}